export default function hbs() {
  // eslint-disable-next-line no-console
  console.log("Templates should be precompiled server side");
}
